export default __webpack_public_path__ + "static/report-content-06-f56503d4324dc6aaeb80c787f19ef93c.png";